import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule, MatGridListModule } from '@angular/material';
import { NgxPaginationModule } from 'ngx-pagination';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TranslateModule } from '@ngx-translate/core';

import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
defineLocale('es', esLocale);

import {
    ModalLogoutComponent,
    ContentHeaderComponent,
    ContentListComponent,
    ModalConfirmComponent,
    LoadingComponent,
    LoadingGlobalComponent,
    ModalNoticeComponent,
    ComboBoxLoadingComponent,
    DetalisEvalueComponent,
    ModalTextComponent,
    NumberPickerComponent,
    ModalTreatmentComponent,
    OtherMethodComponent,
    MethodFiveBecauseComponent,
    MethodIshikawaComponent,
    MethodParetoComponent,
    MethodLluviaComponent
} from './components';

import {
    AppExpandMenu,
    AppExpandSidebar,
    FilterGeneralPipe,
    SearchPipe,
    OrderByPipe
} from './pipes';
import { FormTratmentComponent } from './components/form-tratment/form-tratment.component';
import { ConfirmComponent } from './modals/confirm/confirm.component';
import { TagInputModule } from 'ngx-chips';
import { ChartsModule } from 'ng2-charts';
import { LoadingInterfaceComponent } from './components/loading-interface/loading-interface.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { TracingItemComponent } from './components/tracing-item/tracing-item.component';
import { PaginationButtonsComponent } from './components/pagination-buttons/pagination-buttons.component';
import { HistoryItemComponent } from './components/history-item/history-item.component';
import { AnalysisComponent } from './components/analysis/analysis.component';
import { FormApprovalComponent } from './components/form-approval/form-approval.component';
import { ReminderComponent } from './modals/reminder/reminder.component';
import { StatusComponent } from './modals/status/status.component';
import { ResponsibleComponent } from './modals/responsible/responsible.component';

@NgModule({
    imports: [
        CommonModule,
        AngularFontAwesomeModule,
        FormsModule,
        ReactiveFormsModule,
        MatExpansionModule,
        MatGridListModule,
        NgxPaginationModule,
        BsDropdownModule.forRoot(),
        RouterModule,
        NgbModule,
        BsDatepickerModule,
        TranslateModule,
        TagInputModule,
        ChartsModule,
        MatExpansionModule
    ],
    declarations: [
        ModalLogoutComponent,
        AppExpandMenu,
        AppExpandSidebar,
        ContentHeaderComponent,
        ContentListComponent,
        FilterGeneralPipe,
        SearchPipe,
        ModalConfirmComponent,
        OrderByPipe,
        LoadingComponent,
        ModalNoticeComponent,
        LoadingGlobalComponent,
        ComboBoxLoadingComponent,
        ComboBoxLoadingComponent,
        DetalisEvalueComponent,
        ModalTextComponent,
        NumberPickerComponent,
        ModalTreatmentComponent,
        OtherMethodComponent,
        MethodFiveBecauseComponent,
        MethodIshikawaComponent,
        MethodParetoComponent,
        MethodLluviaComponent,
        FormTratmentComponent,
        ConfirmComponent,
        LoadingInterfaceComponent,
        BreadcrumbsComponent,
        TracingItemComponent,
        AnalysisComponent,
        FormApprovalComponent,
        PaginationButtonsComponent,
        HistoryItemComponent,
        ReminderComponent,
        StatusComponent,
        ResponsibleComponent
    ],
    exports: [
        ModalLogoutComponent,
        AppExpandMenu,
        AppExpandSidebar,
        ContentHeaderComponent,
        ContentListComponent,
        FilterGeneralPipe,
        SearchPipe,
        ModalConfirmComponent,
        OrderByPipe,
        LoadingComponent,
        ModalNoticeComponent,
        LoadingGlobalComponent,
        ComboBoxLoadingComponent,
        DetalisEvalueComponent,
        ModalTextComponent,
        NumberPickerComponent,
        ModalTreatmentComponent,
        OtherMethodComponent,
        MethodFiveBecauseComponent,
        MethodIshikawaComponent,
        MethodParetoComponent,
        MethodLluviaComponent,
        FormTratmentComponent,
        ConfirmComponent,
        LoadingInterfaceComponent,
        BreadcrumbsComponent,
        TracingItemComponent,
        AnalysisComponent,
        FormApprovalComponent,
        PaginationButtonsComponent,
        HistoryItemComponent,
        ReminderComponent,
        StatusComponent,
        ResponsibleComponent
    ],
    entryComponents: [
        ModalLogoutComponent,
        ModalConfirmComponent,
        ModalNoticeComponent,
        ModalTextComponent,
        ModalTreatmentComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class SharedModule {}
